import { render, staticRenderFns } from "./groupFarm1.vue?vue&type=template&id=fcb14cb0&scoped=true"
import script from "./groupFarm1.vue?vue&type=script&lang=js"
export * from "./groupFarm1.vue?vue&type=script&lang=js"
import style0 from "./groupFarm1.vue?vue&type=style&index=0&id=fcb14cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb14cb0",
  null
  
)

export default component.exports